import React from 'react';
import { MapPin, Clock, Mail } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="paper-texture min-h-screen py-24">
      <div className="max-w-5xl mx-auto px-6">
        <h1 className="font-display text-5xl text-center mb-6" data-testid="contact-title">
          Get in Touch
        </h1>
        <p className="text-lg text-[#5C5855] text-center mb-16 max-w-2xl mx-auto">
          Have questions about our products or want to stock our preserves in your store? We'd love to hear from you.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-white border border-alt-bg p-8 soft-shadow">
              <div className="flex items-start space-x-4">
                <MapPin className="w-8 h-8 text-cape-red flex-shrink-0" />
                <div>
                  <h2 className="font-display text-2xl mb-3">Visit Our Shop</h2>
                  <p className="text-[#2D2A26] leading-relaxed">
                    Preserves of Cape Cod<br />
                    45 Seth Goodspeed Way<br />
                    Osterville, Massachusetts 02655
                  </p>
                  <a
                    href="https://www.google.com/maps/dir/?api=1&destination=45+SETH+GOODSPEED+WAY+OSTERVILLE+MA+02655"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cape-red hover:text-[#A30000] font-semibold mt-3 inline-block"
                  >
                    Get Directions →
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white border border-alt-bg p-8 soft-shadow">
              <div className="flex items-start space-x-4">
                <Clock className="w-8 h-8 text-cape-red flex-shrink-0" />
                <div>
                  <h2 className="font-display text-2xl mb-3">Business Hours</h2>
                  <div className="space-y-2 text-[#2D2A26]">
                    <div className="flex justify-between">
                      <span>Monday - Friday</span>
                      <span className="font-semibold">9:00 AM - 5:00 PM</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Saturday</span>
                      <span className="text-[#8C8885]">Closed</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Sunday</span>
                      <span className="text-[#8C8885]">Closed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white border border-alt-bg p-8 soft-shadow">
              <div className="flex items-start space-x-4">
                <Mail className="w-8 h-8 text-cape-red flex-shrink-0" />
                <div>
                  <h2 className="font-display text-2xl mb-3">Email Us</h2>
                  <p className="text-[#2D2A26] mb-3">
                    Have a question or want to place a wholesale order?
                  </p>
                  <a
                    href="mailto:contactus@preservesofcapecod.com"
                    className="text-cape-red hover:text-[#A30000] font-semibold text-lg"
                  >
                    contactus@preservesofcapecod.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div>
            <div className="bg-alt-bg p-8 mb-8">
              <h2 className="font-display text-2xl mb-4">Wholesale Inquiries</h2>
              <p className="text-[#2D2A26] leading-relaxed mb-4">
                Interested in stocking our preserves in your store or gift shop? We partner with retailers throughout Cape Cod and beyond.
              </p>
              <p className="text-[#2D2A26] leading-relaxed">
                Contact us at the email above to discuss wholesale pricing and minimum order quantities.
              </p>
            </div>

            <div className="bg-alt-bg p-8">
              <h2 className="font-display text-2xl mb-4">Find Our Products</h2>
              <p className="text-[#2D2A26] leading-relaxed mb-4">
                Our preserves are available at select retail stores and gift shops throughout Massachusetts. You can also order directly through our online store for home delivery.
              </p>
              <p className="text-[#2D2A26] leading-relaxed">
                Don't see our products at your favorite local store? Ask them to stock Preserves of Cape Cod!
              </p>
            </div>

            <div className="mt-8 p-8 border-l-4 border-cape-red bg-white">
              <p className="handwritten text-2xl text-deep-berry mb-2">
                Made with care in Cape Cod
              </p>
              <p className="text-sm text-[#8C8885]">
                Every jar of our preserves is crafted using our unique small batch process
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
